import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import OutlinedInput from '@mui/material/OutlinedInput';
import Select from '@mui/material/Select';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import BtnOutlineGradient from 'src/components/common/button/BtnOutlineGradient';
import StackRow from './StackRow';

type GenerateCreateFieldChildType = {
  field: any;
  position: number;
  idxParent: number;
  handleChangeValue: (value: any, position: number) => void;
  removeQuestion: (position: number) => void;
  handleModified: (order: number) => void;
};

const inputStyle = {
  fontSize: '14px',
  my: '8px',
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: '#BDBDBD',
  },
  '& .MuiInputBase-input': { padding: '8px 14px', height: '32px' },
  '& input::placeholder': {
    fontSize: '14px',
    fontWeight: 500,
    color: '#CCD1D9',
    opacity: 1,
  },
  backgroundColor: 'primary.light',
  flex: 1,
};

const options = [
  { label: 'テキスト入力', value: 'text' },
  { label: 'チェックボックス（複数選択が可能）', value: 'checkbox' },
  { label: 'ラジオボタン（1つだけ選択可能）', value: 'radio' },
  { label: 'セレクトメニュー（プルダウンから選択）', value: 'select' },
];

const extendOptions = [
  { label: '-', value: '-' },
  { label: '年月', value: 'year_month' },
  { label: 'テキスト入力', value: 'text' },
];

const extendSelectOptions = [
  { label: '-', value: '-' },
  { label: 'テキスト入力', value: 'text' },
  { label: 'セレクトメニュー（プルダウンから選択）', value: 'select' }, //部位
];

const extendCheckboxOptions = [
  { label: '-', value: '-' },
  { label: 'テキスト入力', value: 'text' },
  { label: 'チェックボックス（複数選択が可能）', value: 'checkbox' },
];

const GenerateCreateFieldChild: React.FC<GenerateCreateFieldChildType> = (
  props
) => {
  const field = props.field;

  const handleSelectChange = (event: any, position: number) => {
    const { value } = event.target;
    let defaultValue = {
      type: value,
      label: '',
      help_text: '',
      field_id: '',
      required: false,
      order: field.order || '',
      parent_id: props.idxParent,
    };
    let question = {};
    switch (value) {
      case 'text':
        question = { ...defaultValue, min_length: '', max_length: '' };
        break;
      case 'checkbox':
        question = { ...defaultValue, options: [''], others: '' };
        break;
      case 'radio':
        question = { ...defaultValue, options: [''], others: '' };
        break;
      case 'select':
        question = {
          ...defaultValue,
          options: [''],
          others: '',
          allow_multiple: false,
          dependent_fields: [
            {
              type: value,
              label: '最終発作日',
              help_text: '',
              options: [''],
            },
          ],
        };
        break;
      default:
        question = {
          ...defaultValue,
          min_length: '',
          max_length: '',
        };
        break;
    }
    props.handleChangeValue(question, position);
    props.handleModified(field.order);
  };

  const handleInputOptionChange = (
    event: any,
    idx: number,
    position: number
  ) => {
    const { value } = event.target;
    let question = { ...field };
    question['options'][idx] = value;
    props.handleChangeValue(question, position);
    props.handleModified(field.order);
  };

  const addOption = (position: number) => {
    let question = { ...field };
    question['options'].push('');
    props.handleChangeValue(question, position);
    props.handleModified(field.order);
  };

  const removeOption = (idx: number, position: number) => {
    let question = { ...field };
    question['options'].splice(idx, 1);
    props.handleChangeValue(question, position);
    props.handleModified(field.order);
  };

  const handleInputChange = (event: any, position: number) => {
    const { name, value } = event.target;
    let question = { ...field, [name]: value };
    props.handleChangeValue(question, position);
    props.handleModified(field.order);
  };

  const handleSelectExpandChange = (event: any, position: number) => {
    const { value } = event.target;
    let question = { ...field };
    if (value === 'year_month') {
      question['dependent_fields'] = [
        {
          type: value,
          label: '',
          help_text: '',
        },
      ];
    } else if (value === 'select' || value === 'checkbox') {
      question['dependent_fields'] = [
        {
          type: value,
          label: '',
          help_text: '',
          options: [''],
        },
      ];
    } else if (value === 'text') {
      question['dependent_fields'] = [
        {
          type: value,
          label: '',
          help_text: '',
        },
      ];
    } else {
      question['dependent_fields'] = [];
    }
    props.handleChangeValue(question, position);
    props.handleModified(field.order);
  };

  const handleInputExpandChange = (event: any, position: number) => {
    const { name, value } = event.target;
    let question = { ...field };
    question['dependent_fields'][0][name] = value;
    props.handleChangeValue(question, position);
    props.handleModified(field.order);
  };

  const handleInputOptionExpandChange = (
    event: any,
    idx: number,
    position: number
  ) => {
    const { value } = event.target;
    let question = { ...field };
    question['dependent_fields'][0]['options'][idx] = value;
    props.handleChangeValue(question, position);
    props.handleModified(field.order);
  };

  const addOptionExpand = (position: number) => {
    let question = { ...field };
    question['dependent_fields'][0]['options'].push('');
    props.handleChangeValue(question, position);
    props.handleModified(field.order);
  };

  const removeOptionExpand = (idx: number, position: number) => {
    let question = { ...field };
    question['dependent_fields'][0]['options'].splice(idx, 1);
    props.handleChangeValue(question, position);
    props.handleModified(field.order);
  };

  const handleInputOptionChildChange = (
    event: any,
    idx: number,
    position: number
  ) => {
    const { value } = event.target;
    let question = { ...field };
    question['options'][idx] = value;
    props.handleChangeValue(question, position);
    props.handleModified(field.order);
  };

  const removeOptionChild = (idx: number, position: number) => {
    let question = { ...field };
    question['options'].splice(idx, 1);
    props.handleChangeValue(question, position);
    props.handleModified(field.order);
  };

  const addOptionChild = (position: number) => {
    let question = { ...field };
    question['options'].push('');
    props.handleChangeValue(question, position);
    props.handleModified(field.order);
  };

  return (
    <Stack width={'100%'}>
      <StackRow>
        <Typography width={'100px'}>タイプ</Typography>
        <Select
          value={field.type}
          onChange={(e) => handleSelectChange(e, props.position)}
          sx={{
            backgroundColor: 'primary.light',
            height: '48px',
            '& .MuiInputBase-input.MuiOutlinedInput-input': {
              p: '6px 14px',
            },
            width: '200px',
          }}
        >
          {options.map((option: any, idx: number) => {
            return (
              <MenuItem value={option.value} key={idx}>
                {option.label}
              </MenuItem>
            );
          })}
        </Select>
        <Box
          component={'img'}
          src='/images/icons/ic-trash.svg'
          alt='trash'
          sx={{ cursor: 'pointer', width: '24px' }}
          onClick={() => props.removeQuestion(props.position)}
        />
      </StackRow>
      {field.type === 'text' && (
        <>
          <StackRow>
            <Typography width={'100px'}>ラベル</Typography>
            <OutlinedInput
              sx={inputStyle}
              inputProps={{
                sx: {
                  backgroundColor: 'primary.light',
                },
              }}
              name={'label'}
              value={field.label}
              onChange={(event) => handleInputChange(event, props.position)}
            />
          </StackRow>
          <StackRow>
            <Typography width={'100px'}>補足説明</Typography>
            <OutlinedInput
              sx={inputStyle}
              inputProps={{
                sx: {
                  backgroundColor: 'primary.light',
                },
              }}
              name={'help_text'}
              value={field.help_text}
              onChange={(event) => handleInputChange(event, props.position)}
            />
          </StackRow>
          <StackRow>
            <Typography width={'100px'}>拡張</Typography>
            <Select
              value={
                (Array.isArray(field.dependent_fields) &&
                  field.dependent_fields[0]?.type) ||
                '-'
              }
              onChange={(e) => handleSelectExpandChange(e, props.position)}
              sx={{
                backgroundColor: 'primary.light',
                height: '48px',
                '& .MuiInputBase-input.MuiOutlinedInput-input': {
                  p: '6px 14px',
                },
                width: '200px',
              }}
            >
              {extendOptions.map((option: any, idx: number) => {
                return (
                  <MenuItem value={option.value} key={idx}>
                    {option.label}
                  </MenuItem>
                );
              })}
            </Select>
          </StackRow>
          {Array.isArray(field.dependent_fields) &&
            field.dependent_fields.length > 0 &&
            field.dependent_fields[0]?.type !== '-' && (
              <>
                <StackRow>
                  <Typography width={'100px'}>ラベル(拡張)</Typography>
                  <OutlinedInput
                    sx={inputStyle}
                    inputProps={{
                      sx: {
                        backgroundColor: 'primary.light',
                      },
                    }}
                    name={'label'}
                    value={field.dependent_fields[0]?.label}
                    onChange={(event) =>
                      handleInputExpandChange(event, props.position)
                    }
                  />
                </StackRow>
              </>
            )}
            
          {Array.isArray(field.dependent_fields) &&
            field.dependent_fields[0]?.type === 'text' && (
              <>
                <Stack
                  direction='row'
                  spacing={'8px'}
                  justifyContent={'flex-start'}
                  // alignItems={'center'}
                  width={'100%'}
                  my={'8px'}
                >
                  <StackRow>
                    <Typography width={'100px'}>補足説明(拡張)</Typography>
                    <OutlinedInput
                      sx={inputStyle}
                      inputProps={{
                        sx: {
                          backgroundColor: 'primary.light',
                        },
                      }}
                      name={'help_text'}
                      value={field.dependent_fields[0]?.help_text}
                      onChange={(event) => handleInputExpandChange(event, props.position)}
                    />
                  </StackRow>
                </Stack>
                </>
            )}
          {Array.isArray(field.dependent_fields) &&
            field.dependent_fields[0]?.type === 'select' && (
              <>
                <Stack
                  direction='row'
                  spacing={'8px'}
                  justifyContent={'flex-start'}
                  // alignItems={'center'}
                  width={'100%'}
                  my={'8px'}
                >
                  <Typography width={'100px'}>選択肢(拡張)</Typography>
                  <Stack>
                    {field.dependent_fields[0]?.options.map(
                      (option: string, idx: number) => {
                        return (
                          <Stack
                            direction={'row'}
                            spacing={'4px'}
                            mb={'4px'}
                            key={idx}
                          >
                            <OutlinedInput
                              sx={inputStyle}
                              inputProps={{
                                sx: {
                                  backgroundColor: 'primary.light',
                                },
                              }}
                              name={'option'}
                              value={option}
                              onChange={(event) =>
                                handleInputOptionExpandChange(
                                  event,
                                  idx,
                                  props.position
                                )
                              }
                            />
                            <Box
                              component={'img'}
                              src='/images/icons/ic-trash.svg'
                              alt='trash'
                              sx={{ cursor: 'pointer', width: '24px' }}
                              onClick={() =>
                                removeOptionExpand(idx, props.position)
                              }
                            />
                          </Stack>
                        );
                      }
                    )}
                  </Stack>
                </Stack>
                <Stack>
                  <Typography width={'100px'}></Typography>
                  <Stack>
                    <BtnOutlineGradient
                      text='選択肢を追加'
                      handleButtonClick={() => addOptionExpand(props.position)}
                      width='100px'
                    />
                  </Stack>
                </Stack>
              </>
            )}
        </>
      )}
      {(field.type === 'radio') && (
        <>
          <Stack
            direction='row'
            spacing={'8px'}
            justifyContent={'flex-start'}
            // alignItems={'center'}
            width={'100%'}
            my={'8px'}
          >
            <Typography width={'120px'} style={{ marginTop: '8px' }}>
              選択肢
            </Typography>
            <Stack>
              {field.options.map((option: string, idx: number) => {
                return (
                  <Stack direction={'row'} spacing={'4px'} mb={'4px'} key={idx}>
                    <OutlinedInput
                      sx={{ ...inputStyle, width: '150px' }}
                      inputProps={{
                        sx: {
                          backgroundColor: 'primary.light',
                        },
                      }}
                      name={'option'}
                      value={option}
                      onChange={(event) =>
                        handleInputOptionChange(event, idx, props.position)
                      }
                    />
                    <Box
                      component={'img'}
                      src='/images/icons/ic-trash.svg'
                      alt='trash'
                      sx={{ cursor: 'pointer', width: '24px' }}
                      onClick={() => removeOption(idx, props.position)}
                    />
                  </Stack>
                );
              })}
            </Stack>
          </Stack>
          <Stack direction={'row'} spacing={'4px'} mb={'4px'}>
            <Typography width={'120px'}></Typography>
            <Stack>
              <BtnOutlineGradient
                text='選択肢を追加'
                handleButtonClick={() => addOption(props.position)}
                width='100px'
              />
            </Stack>
          </Stack>
        </>
      )}
      {(field.type === 'checkbox') && (
        <>
          <StackRow>
            <Typography width={'100px'}>ラベル</Typography>
            <OutlinedInput
              sx={inputStyle}
              inputProps={{
                sx: {
                  backgroundColor: 'primary.light',
                },
              }}
              name={'label'}
              value={field.label}
              onChange={(event) => handleInputChange(event, props.position)}
            />
          </StackRow>
          <Stack
            direction='row'
            spacing={'8px'}
            justifyContent={'flex-start'}
            // alignItems={'center'}
            width={'100%'}
            my={'8px'}
          >
            <Typography width={'120px'} style={{ marginTop: '8px' }}>
              選択肢
            </Typography>
            <Stack>
              {field.options.map((option: string, idx: number) => {
                return (
                  <Stack direction={'row'} spacing={'4px'} mb={'4px'} key={idx}>
                    <OutlinedInput
                      sx={{ ...inputStyle, width: '150px' }}
                      inputProps={{
                        sx: {
                          backgroundColor: 'primary.light',
                        },
                      }}
                      name={'option'}
                      value={option}
                      onChange={(event) =>
                        handleInputOptionChange(event, idx, props.position)
                      }
                    />
                    <Box
                      component={'img'}
                      src='/images/icons/ic-trash.svg'
                      alt='trash'
                      sx={{ cursor: 'pointer', width: '24px' }}
                      onClick={() => removeOption(idx, props.position)}
                    />
                  </Stack>
                );
              })}
            </Stack>
          </Stack>
          <Stack direction={'row'} spacing={'4px'} mb={'4px'}>
            <Typography width={'120px'}></Typography>
            <Stack>
              <BtnOutlineGradient
                text='選択肢を追加'
                handleButtonClick={() => addOption(props.position)}
                width='100px'
              />
            </Stack>
          </Stack>
          <StackRow>
            <Typography width={'100px'}>拡張</Typography>
            <Select
              value={
                (Array.isArray(field.dependent_fields) &&
                  field.dependent_fields[0]?.type) ||
                '-'
              }
              onChange={(e) => handleSelectExpandChange(e, props.position)}
              sx={{
                backgroundColor: 'primary.light',
                height: '48px',
                '& .MuiInputBase-input.MuiOutlinedInput-input': {
                  p: '6px 14px',
                },
                width: '200px',
              }}
            >
              {extendCheckboxOptions.map((option: any, idx: number) => {
                return (
                  <MenuItem value={option.value} key={idx}>
                    {option.label}
                  </MenuItem>
                );
              })}
            </Select>
          </StackRow>
          {Array.isArray(field.dependent_fields) &&
            field.dependent_fields.length > 0 &&
            field.dependent_fields[0]?.type !== '-' && (
              <>
                <StackRow>
                  <Typography width={'100px'}>ラベル(拡張)</Typography>
                  <OutlinedInput
                    sx={inputStyle}
                    inputProps={{
                      sx: {
                        backgroundColor: 'primary.light',
                      },
                    }}
                    name={'label'}
                    value={field.dependent_fields[0]?.label}
                    onChange={(event) =>
                      handleInputExpandChange(event, props.position)
                    }
                  />
                </StackRow>
              </>
            )}
            {Array.isArray(field.dependent_fields) &&
            field.dependent_fields[0]?.type === 'checkbox' && (
              <>
                <Stack
                  direction='row'
                  spacing={'8px'}
                  justifyContent={'flex-start'}
                  // alignItems={'center'}
                  width={'100%'}
                  my={'8px'}
                >
                  <Typography width={'100px'}>選択肢(拡張)</Typography>
                  <Stack>
                    {field.dependent_fields[0]?.options.map(
                      (option: string, idx: number) => {
                        return (
                          <Stack
                            direction={'row'}
                            spacing={'4px'}
                            mb={'4px'}
                            key={idx}
                          >
                            <OutlinedInput
                              sx={inputStyle}
                              inputProps={{
                                sx: {
                                  backgroundColor: 'primary.light',
                                },
                              }}
                              name={'option'}
                              value={option}
                              onChange={(event) =>
                                handleInputOptionExpandChange(
                                  event,
                                  idx,
                                  props.position
                                )
                              }
                            />
                            <Box
                              component={'img'}
                              src='/images/icons/ic-trash.svg'
                              alt='trash'
                              sx={{ cursor: 'pointer', width: '24px' }}
                              onClick={() =>
                                removeOptionExpand(idx, props.position)
                              }
                            />
                          </Stack>
                        );
                      }
                    )}
                  </Stack>
                </Stack>
                <Stack>
                  <Typography width={'100px'}></Typography>
                  <Stack>
                    <BtnOutlineGradient
                      text='選択肢を追加'
                      handleButtonClick={() => addOptionExpand(props.position)}
                      width='100px'
                    />
                  </Stack>
                </Stack>
              </>
            )}
        </>
      )}
      {field.type === 'select' && (
        <>
          <StackRow>
            <Typography width={'100px'}>ラベル</Typography>
            <OutlinedInput
              sx={inputStyle}
              inputProps={{
                sx: {
                  backgroundColor: 'primary.light',
                },
              }}
              name={'label'}
              value={field.label}
              onChange={(event) => handleInputChange(event, props.position)}
            />
          </StackRow>
          <Stack
            direction='row'
            spacing={'8px'}
            justifyContent={'flex-start'}
            // alignItems={'center'}
            width={'100%'}
            my={'8px'}
          >
            <Typography width={'100px'}>選択肢</Typography>
            <Stack>
              {field.options.map((option: string, idx: number) => {
                return (
                  <Stack direction={'row'} spacing={'4px'} mb={'4px'} key={idx}>
                    <OutlinedInput
                      sx={inputStyle}
                      inputProps={{
                        sx: {
                          backgroundColor: 'primary.light',
                        },
                      }}
                      name={'option'}
                      value={option}
                      onChange={(event) =>
                        handleInputOptionChildChange(event, idx, props.position)
                      }
                    />
                    <Box
                      component={'img'}
                      src='/images/icons/ic-trash.svg'
                      alt='trash'
                      sx={{ cursor: 'pointer', width: '24px' }}
                      onClick={() => removeOptionChild(idx, props.position)}
                    />
                  </Stack>
                );
              })}
            </Stack>
          </Stack>
          <Stack>
            <Typography width={'100px'}></Typography>
            <Stack>
              <BtnOutlineGradient
                text='選択肢を追加'
                handleButtonClick={() => addOptionChild(props.position)}
                width='100px'
              />
            </Stack>
          </Stack>
          <StackRow>
            <Typography width={'100px'}>拡張</Typography>
            <Select
              value={
                (Array.isArray(field.dependent_fields) &&
                  field.dependent_fields[0]?.type) ||
                '-'
              }
              onChange={(e) => handleSelectExpandChange(e, props.position)}
              sx={{
                backgroundColor: 'primary.light',
                height: '48px',
                '& .MuiInputBase-input.MuiOutlinedInput-input': {
                  p: '6px 14px',
                },
                width: '200px',
              }}
            >
              {extendSelectOptions.map((option: any, idx: number) => {
                return (
                  <MenuItem value={option.value} key={idx}>
                    {option.label}
                  </MenuItem>
                );
              })}
            </Select>
          </StackRow>
          {Array.isArray(field.dependent_fields) &&
            field.dependent_fields.length > 0 &&
            field.dependent_fields[0]?.type !== '-' && (
              <>
                <StackRow>
                  <Typography width={'100px'}>ラベル(拡張)</Typography>
                  <OutlinedInput
                    sx={inputStyle}
                    inputProps={{
                      sx: {
                        backgroundColor: 'primary.light',
                      },
                    }}
                    name={'label'}
                    value={field.dependent_fields[0]?.label}
                    onChange={(event) =>
                      handleInputExpandChange(event, props.position)
                    }
                  />
                </StackRow>
              </>
            )}
          {Array.isArray(field.dependent_fields) &&
            field.dependent_fields[0]?.type === 'select' && (
              <>
                <Stack
                  direction='row'
                  spacing={'8px'}
                  justifyContent={'flex-start'}
                  // alignItems={'center'}
                  width={'100%'}
                  my={'8px'}
                >
                  <Typography width={'100px'}>選択肢(拡張)</Typography>
                  <Stack>
                    {field.dependent_fields[0]?.options.map(
                      (option: string, idx: number) => {
                        return (
                          <Stack
                            direction={'row'}
                            spacing={'4px'}
                            mb={'4px'}
                            key={idx}
                          >
                            <OutlinedInput
                              sx={inputStyle}
                              inputProps={{
                                sx: {
                                  backgroundColor: 'primary.light',
                                },
                              }}
                              name={'option'}
                              value={option}
                              onChange={(event) =>
                                handleInputOptionExpandChange(
                                  event,
                                  idx,
                                  props.position
                                )
                              }
                            />
                            <Box
                              component={'img'}
                              src='/images/icons/ic-trash.svg'
                              alt='trash'
                              sx={{ cursor: 'pointer', width: '24px' }}
                              onClick={() =>
                                removeOptionExpand(idx, props.position)
                              }
                            />
                          </Stack>
                        );
                      }
                    )}
                  </Stack>
                </Stack>
                <Stack>
                  <Typography width={'100px'}></Typography>
                  <Stack>
                    <BtnOutlineGradient
                      text='選択肢を追加'
                      handleButtonClick={() => addOptionExpand(props.position)}
                      width='100px'
                    />
                  </Stack>
                </Stack>
              </>
            )}
          {/* <StackRow>
            <Typography width={'100px'}>ラベル(拡張)</Typography>
            <OutlinedInput
              sx={inputStyle}
              inputProps={{
                sx: {
                  backgroundColor: 'primary.light',
                },
              }}
              name={'label'}
              value={field.dependent_fields[0]?.label}
              onChange={(event) =>
                handleInputExpandChange(event, props.position)
              }
            />
          </StackRow>
          <Stack
            direction='row'
            spacing={'8px'}
            justifyContent={'flex-start'}
            // alignItems={'center'}
            width={'100%'}
            my={'8px'}
          >
            <Typography width={'100px'}>選択肢(拡張)</Typography>
            <Stack>
              {field.dependent_fields[0]?.options.map(
                (option: string, idx: number) => {
                  return (
                    <Stack
                      direction={'row'}
                      spacing={'4px'}
                      mb={'4px'}
                      key={idx}
                    >
                      <OutlinedInput
                        sx={inputStyle}
                        inputProps={{
                          sx: {
                            backgroundColor: 'primary.light',
                          },
                        }}
                        name={'option'}
                        value={option}
                        onChange={(event) =>
                          handleInputOptionExpandChange(
                            event,
                            idx,
                            props.position
                          )
                        }
                      />
                      <Box
                        component={'img'}
                        src='/images/icons/ic-trash.svg'
                        alt='trash'
                        sx={{ cursor: 'pointer', width: '24px' }}
                        onClick={() => removeOptionExpand(idx, props.position)}
                      />
                    </Stack>
                  );
                }
              )}
            </Stack>
          </Stack>
          <Stack>
            <Typography width={'100px'}></Typography>
            <Stack>
              <BtnOutlineGradient
                text='選択肢を追加'
                handleButtonClick={() => addOptionExpand(props.position)}
                width='100px'
              />
            </Stack>
          </Stack> */}
        </>
      )}
    </Stack>
  );
};

export default GenerateCreateFieldChild;
